const styles = {
  section: {
    padding: '6.2rem 0',
    margin: 0,
    border:0,
  },
  sectionGrey: {
    padding: '6.2rem 0',
    margin: 0,
    border:0,
    backgroundColor: '#f8f9fa',
  },
  h:{
    marginBottom: '2.4rem',
    fontWeight: 500,
    fontSize:'3.2rem',
    color: 'rgb(70, 72, 74)',
    boxSizing: 'border-box',
    lineHeight: 1.2,
    // fontFamily: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif'
  },
  h2:{
    marginBottom: 0,
    // textAlign: 'left',
    fontWeight: 500,
    fontSize:'3.1rem',
    // color: '#696b6e',
    // boxSizing: 'border-box',
    // lineHeight: 1.2,
    // fontFamily: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif'
  },
  h3:{
    marginBottom: '3.4rem',
    fontWeight: 300,
    fontSize:'1.4rem',
    color: '#696b6e',
    boxSizing: 'border-box',
    // lineHeight: 1.2,
    // fontFamily: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif'
  },
  h4:{
    marginBottom: 0,
    // textAlign: 'left',
    fontWeight: 500,
    fontSize:'2.1rem',
    // color: '#696b6e',
    // boxSizing: 'border-box',
    // lineHeight: 1.2,
    // fontFamily: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif'
  },
  img:{
    webkitFilter: 'grayscale(100%)', /* Safari 6.0 - 9.0 */
    filter: 'grayscale(100%)',
  },
  menuItem: {
    textTransform: 'uppercase',
    fontSize: '.95rem',
    letterSpacing: '.1rem',
  },
  contacts: {
    fontSize: '3.0rem',
    // lineHeight: 1.6,
    fontWeight: 300,
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/Styles.jsx